import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import WishlistModal from 'components/Wishlist/WishlistDialog';

import useModal from 'hooks/useModal';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';
import { searchQueryKeys } from 'lib/queryKeys';

import { useUser } from 'providers/UserProvider';

import { getOfferKeywordsSuggestions } from 'services/wishlist';

import HeroMessage from './HeroMessage';
import StoresList from './StoresList';

const NoResultsFound = ({
  gaEventCategory,
  searchQuery,
  searchQuerySuggestedCorrection = null,
}) => {
  const { showModal } = useModal();
  const { isLoggedIn } = useUser();

  // TODO here is correct?
  const { data: wishlistKeywords } = useQuery({
    queryKey: searchQueryKeys.suggestedCorrectionResult({
      searchQuerySuggestedCorrection,
    }),
    queryFn: ({ signal }) =>
      getOfferKeywordsSuggestions(
        {
          genericValue: searchQuerySuggestedCorrection,
        },
        { signal }
      ),
    select: (data) => data ?? [],
    placeholderData: [],
    refetchOnMount: 'always',
    enabled: !!searchQuerySuggestedCorrection,
  });

  useEffect(() => {
    sendEvent({ action: 'no_results_message', category: gaEventCategory });
  }, []);

  const onEditWishlistButtonClick = () => {
    showModal(WishlistModal);
    sendEvent({
      category: gaEventCategory,
      action: isLoggedIn ? 'wishlist_edit_logged' : 'wishlist_edit_unlogged',
    });
  };

  return (
    <div className="flex w-full flex-col border-t border-t-neutral-high-200 dark:border-t-neutral-low-300">
      <HeroMessage
        gaEventCategory={gaEventCategory}
        wishlistKeywords={wishlistKeywords}
        onEditWishlistButtonClick={onEditWishlistButtonClick}
      />
      <Box className="mt-1 border-t-3 border-t-primary-300 p-4">
        <Heading as="h1" className="mb-2" size="size4">
          {placeholder('titles.noResultsFound')}
        </Heading>
        <Text size="size2">
          Você também pode fazer sua busca em lojas parceiras do Promobit,
          encontrando um bom preço avise a comunidade, clicando em{' '}
          <Text as="span" size="size2" bold>
            sugerir oferta.
          </Text>
        </Text>
        <StoresList
          gaEventCategory={gaEventCategory}
          searchQuery={searchQuery}
        />
      </Box>
    </div>
  );
};

NoResultsFound.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  searchQuery: PropTypes.string.isRequired,
  searchQuerySuggestedCorrection: PropTypes.string,
};

export default NoResultsFound;
